import React from 'react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  return <section className="py-24 bg-wine-dark text-cream px-6 relative overflow-hidden" data-id="element-95">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-96">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-amber rounded-full blur-3xl" data-id="element-97"></div>
        <div className="absolute top-1/2 right-0 w-64 h-64 bg-wine-light rounded-full blur-3xl" data-id="element-98"></div>
      </div>

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-100">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-101">
            La solución es ridículamente simple <br data-id="element-102" />
            <span className="text-amber italic" data-id="element-103">(y por eso funciona)</span>
          </h2>
          <p className="text-xl text-cream/80 max-w-2xl mx-auto" data-id="element-104">
            En vez de “grandes movimientos”, vas a usar dos herramientas
            diseñadas para eliminar el riesgo:
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 mb-16" data-id="element-105">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10" data-id="element-106">
            <div className="h-12 w-12 bg-amber rounded-full flex items-center justify-center mb-6 font-serif text-2xl font-bold text-wine-dark" data-id="element-107">
              1
            </div>
            <h3 className="text-2xl font-bold text-amber mb-4" data-id="element-108">
              Micro-Inicios
            </h3>
            <p className="text-cream/80 leading-relaxed" data-id="element-109">
              Acercamientos de 5 minutos que no activan pena ni defensas.
              Pequeños gestos que abren la puerta sin tirarla abajo.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10" data-id="element-110">
            <div className="h-12 w-12 bg-amber rounded-full flex items-center justify-center mb-6 font-serif text-2xl font-bold text-wine-dark" data-id="element-111">
              2
            </div>
            <h3 className="text-2xl font-bold text-amber mb-4" data-id="element-112">
              Semáforo de Comodidad
            </h3>
            <p className="text-cream/80 leading-relaxed mb-6" data-id="element-113">
              Una forma rápida de saber si hoy es verde, amarillo o rojo… sin
              drama.
            </p>

            {/* Visual Semáforo */}
            <div className="flex justify-center gap-4" data-id="element-114">
              <div className="flex flex-col items-center gap-2" data-id="element-115">
                <div className="w-8 h-8 rounded-full bg-green-500 shadow-[0_0_15px_rgba(34,197,94,0.5)]" data-id="element-116"></div>
                <span className="text-xs text-cream/60" data-id="element-117">Verde</span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-118">
                <div className="w-8 h-8 rounded-full bg-yellow-500 shadow-[0_0_15px_rgba(234,179,8,0.5)]" data-id="element-119"></div>
                <span className="text-xs text-cream/60" data-id="element-120">Amarillo</span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-121">
                <div className="w-8 h-8 rounded-full bg-red-500 shadow-[0_0_15px_rgba(239,68,68,0.5)]" data-id="element-122"></div>
                <span className="text-xs text-cream/60" data-id="element-123">Rojo</span>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="bg-amber/10 p-8 rounded-xl border border-amber/20 text-center" data-id="element-124">
          <p className="text-xl md:text-2xl font-serif italic text-cream" data-id="element-125">
            "Eso cambia todo por una razón:{' '}
            <strong className="text-amber not-italic" data-id="element-126">
              porque deja de ser adivinar
            </strong>
            . Ya no tienes que lanzarte al vacío. Solo tienes que iniciar
            chiquito… y respetar el ritmo."
          </p>
        </div>
      </div>
    </section>;
}